module.exports = __webpack_public_path__ + "static/img/文旅.ecfe77b0.png";